var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.response ? _c('div', [_c('b-card', [_c('h5', {
    staticClass: "mb-3"
  }, [_vm._v("📦 Import Result Summary")]), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('b-alert', {
    staticClass: "p-2",
    attrs: {
      "show": "",
      "variant": "secondary"
    }
  }, [_vm._v("Total Rows: "), _c('strong', {
    staticClass: "ml-2"
  }, [_vm._v(" " + _vm._s(_vm.response.total_rows))])])], 1), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('b-alert', {
    staticClass: "p-2",
    attrs: {
      "show": "",
      "variant": "success"
    }
  }, [_vm._v("Success: "), _c('strong', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.response.success_count))])])], 1), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('b-alert', {
    staticClass: "p-2",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v("Errors: "), _c('strong', {
    staticClass: "ml-2"
  }, [_vm._v(_vm._s(_vm.response.error_count))])])], 1)], 1)], 1), _vm.response.success_data && _vm.response.success_data.length ? _c('b-card', {
    attrs: {
      "border-variant": "success"
    }
  }, [_c('h5', {
    staticClass: "text-success mb-3"
  }, [_vm._v("✅ Success Data")]), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "small": "",
      "items": _vm.response.success_data,
      "fields": _vm.successFields
    },
    scopedSlots: _vm._u([{
      key: "cell(days_processed)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(data.item.days_processed) + " days ")];
      }
    }], null, false, 2416004193)
  })], 1) : _vm._e(), _vm.response.errors && _vm.response.errors.length ? _c('b-card', {
    attrs: {
      "border-variant": "danger"
    }
  }, [_c('h5', {
    staticClass: "text-danger mb-3"
  }, [_vm._v("❌ Error Data")]), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "small": "",
      "items": _vm.response.errors,
      "fields": _vm.errorFields,
      "thead-class": "text-nowrap"
    },
    scopedSlots: _vm._u([{
      key: "cell(errors)",
      fn: function fn(data) {
        return [_c('ul', {
          staticClass: "mb-0"
        }, _vm._l(data.item.errors, function (err, index) {
          return _c('li', {
            key: index
          }, [_vm._v(_vm._s(err))]);
        }), 0)];
      }
    }, {
      key: "cell(fleet_name)",
      fn: function fn(data) {
        var _data$item$fleet_name, _data$item;
        return [_c('div', {
          staticClass: "text-nowrap"
        }, [_vm._v(_vm._s((_data$item$fleet_name = (_data$item = data.item) === null || _data$item === void 0 ? void 0 : _data$item.fleet_name) !== null && _data$item$fleet_name !== void 0 ? _data$item$fleet_name : '-'))])];
      }
    }], null, false, 4047344477)
  })], 1) : _vm._e()], 1) : _vm._e();

}
var staticRenderFns = []

export { render, staticRenderFns }